import { defineStore } from 'pinia'
import type { Microsite } from '../interfaces/Microsite'

export const useMicrositeStore = defineStore('microsite', {
  state: () => ({
    microsite: null as Microsite | null
  }),
  actions: {
    setMicrosite (micrositeData: Microsite) {
      this.microsite = micrositeData
    }
  }
})
